import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

@Component({
    selector: 'app-activation-redirect',
    templateUrl: './activation-redirect.component.html',
    styleUrl: './activation-redirect.component.scss',
    standalone: false
})
export class ActivationRedirectComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private cookiesService = inject(CookieService);
  private domainCookieName = 'Organisation_Domain';
  
  currentYear = new Date().getFullYear();
  isWelcome: boolean = false;
  domain: string = '';

  ngOnInit() {    
    this.isWelcome = !!this.route.snapshot.queryParamMap.get('isWelcome');
    this.domain = this.cookiesService.get(this.domainCookieName);
  }

  redirectUrl() {
    return this.domain || window.EveryBuddy.AngularUrl;
  }


  backgroundImageUrl(): string {
    return `url(${window.EveryBuddy.WebAPI}/img/backgrounds/3.png)`;
  }
}
